import {
  FileDto,
  UpdateFileDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { DOMAIN_FILES } from "../domain";

import { filesApi } from "@api/services";
import { ACTION_GET_FOLDER, DOMAIN_FOLDERS, roleGuard } from "@api";

export const ACTION_UPDATE_FILE = "UPDATE_FILE";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type UpdateFormRequest = {
  fileId: string;
  dto: UpdateFileDto;
};

const updateFile = async (req: UpdateFormRequest): Promise<FileDto> => {
  const response = await filesApi.filesControllerUpdateUserFile(req.fileId, req.dto);

  return response.data;
};

export const useUpdateFile = (
  user: UserProfileDto | null,
): {
  updateFile: UseMutateFunction<FileDto, Error, UpdateFormRequest, unknown>;
  updateFileEnabled: boolean;
  isSuccessUpdateFile: boolean;
  isPendingUpdateFile: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FILES, ACTION_UPDATE_FILE],
    mutationFn: enabled ? updateFile : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FOLDERS, ACTION_GET_FOLDER],
      });
    },
  });

  return {
    updateFile: mutate,
    updateFileEnabled: enabled,
    isSuccessUpdateFile: isSuccess,
    isPendingUpdateFile: isPending,
  };
};
